var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup2EmptyThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 4,
    fill: "#E9ECEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.25 60.3333H30V33.5H46.875V29.6667H30C27.9375 29.6667 26.25 31.3917 26.25 33.5V60.3333C26.25 62.4417 27.9375 64.1667 30 64.1667H56.25C58.3125 64.1667 60 62.4417 60 60.3333V43.0833H56.25V60.3333ZM41.6438 54.2575L37.9688 49.7342L32.8125 56.5H53.4375L46.8 47.4725L41.6438 54.2575ZM60 29.6667V23.9167H56.25V29.6667H50.625C50.6437 29.6858 50.625 33.5 50.625 33.5H56.25V39.2308C56.2687 39.25 60 39.2308 60 39.2308V33.5H65.625V29.6667H60Z",
    fill: "#6D6D6D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 46,
    fill: "white",
    transform: "translate(22.5 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2EmptyThumbnail);
export default __webpack_public_path__ + "static/media/Group 2EmptyThumbnail.a449af7dbc03a331cc11de9d345e1bc6.svg";
export { ForwardRef as ReactComponent };